import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AssistService from '../../service/AssistService';
import { AssistTypeListResp } from "domain/payload/response/assist/AssistTypeListResp";

const Assist: React.FC = () => {
  const navigate = useNavigate();
  const [assistList, setAssistList] = useState<AssistTypeListResp[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>('');
  
  const { profile } = useSelector((state: any) => state.auth);
  const assistService = AssistService();

  const fetchAssistList = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = profile?.data?.token;
      if (!token) {
        window.alert('Token tidak ditemukan. Silakan login kembali.');
        return;
      }
      
      const response = await assistService.assistTypeList(token);
      
      if (response.status === 'T' && Array.isArray(response.data)) {
        setAssistList(response.data);
      } else {
        throw new Error(response.message || 'Gagal memuat daftar assist');
      }
    } catch (error: any) {
      console.error('Error fetching assist list:', error);
      const errorMessage = error.message || 'Terjadi kesalahan saat memuat data assist';
      setError(errorMessage);
      window.alert(`Error: ${errorMessage}`);
      setAssistList([]);
    } finally {
      setLoading(false);
    }
  }, [profile]);

  useEffect(() => {
    if (profile) {
      fetchAssistList();
    }
  }, [profile, fetchAssistList]);

  const handleNavigate = (assist: AssistTypeListResp) => {
    if (assist.code === 'APNC') {
      navigate('/assist-change-phone-number-activation');
    } else if (assist.code === 'APFV') {
      navigate('/assist-field-visit');
    } else {
      alert(`Fitur ${assist.name} sedang dalam pengembangan`);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const filteredAssistList = assistList.filter(assist =>
    assist.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    assist.code.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (!profile) {
    return (
      <div className="page-wrapper" style={{ minHeight: '100vh' }}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <h5 style={{ flex: 1 }}>Assist</h5>
              <div>
                <p>TransMore Assist</p>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="p-4 bg-white">
              <div className="alert alert-warning">
                <p className="mb-0">Silakan login terlebih dahulu untuk mengakses fitur Assist.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper" style={{ minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          <div className="d-flex">
            <h5 style={{ flex: 1 }}>Assist</h5>
            <div>
              <p>TransMore Assist</p>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="p-4 bg-white">            
            <div className="mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                style={{ height: '42px' }}
                value={searchQuery}
                onChange={handleSearchChange}
                disabled={loading}
              />
            </div>

            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Memuat daftar assist...</p>
              </div>
            ) : error ? (
              <div className="alert alert-danger">
                <p className="mb-2">{error}</p>
              </div>
            ) : filteredAssistList.length === 0 ? (
              <div className="text-center py-4">
                <p className="text-muted">
                  {searchQuery ? 'Tidak ada assist yang sesuai dengan pencarian' : 'Belum ada assist tersedia'}
                </p>
              </div>
            ) : (
              <div className="d-flex flex-wrap gap-3">
                {filteredAssistList.map((assist) => (
                    <button
                    key={assist.id}
                    className="btn btn-primary"
                    style={{
                        flex: '1 1 380px',
                        height: '180px',
                        fontSize: '22px',
                        fontWeight: 500,
                        borderRadius: '8px',
                        opacity: assist.code === 'APNC' || assist.code === 'APFV' ? 1 : 0.7,
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        padding: '15px',
                    }}
                    onClick={() => handleNavigate(assist)}
                    >
                    {assist.name}
                    </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assist;